
const TireTreadSpecs = (props) => {
    return (
        <div className='tread-depth'>
            <div className='tread-depth__specs'>
                <h3 className='tread-depth__heading'>{props.Label}</h3>
                <div className='tread-depth__specs-wrapper'>
                    {props.TreadDepths.map((spec) =>
                        <>
                            <div className='tread-depth__label'>
                                Tire {spec.id}
                            </div>
                            <div className='tread-depth__value'>
                                {spec.value}/32"
                            </div>
                        </>
                    )}
                </div>
            </div>
            <div className='tread-depth__image'>
                <img src={props.CDNImagePath} alt='' loading='lazy' />
            </div>
        </div >
    );
};

export default TireTreadSpecs;